module.exports = __webpack_public_path__ + "img/vpo_v.2ab9281f.png";